var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0837 3.20831C11.0837 2.72507 10.6919 2.33331 10.2087 2.33331C9.72541 2.33331 9.33366 2.72507 9.33366 3.20831V6.41665H9.04199C6.62574 6.41665 4.66699 8.3754 4.66699 10.7916V16.625C4.66699 19.6856 7.14808 22.1666 10.2087 22.1666H13.1253V24.7916C13.1253 25.2749 13.5171 25.6666 14.0003 25.6666C14.4836 25.6666 14.8753 25.2749 14.8753 24.7916V22.1666H17.792C20.8526 22.1666 23.3337 19.6856 23.3337 16.625V10.7916C23.3337 8.3754 21.3749 6.41665 18.9587 6.41665H18.667V3.20831C18.667 2.72507 18.2752 2.33331 17.792 2.33331C17.3088 2.33331 16.917 2.72507 16.917 3.20831V6.41665H11.0837V3.20831Z",
    fill: "#142A6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.1fb139ec5473e3a647b79c6d5c813465.svg";
export { ForwardRef as ReactComponent };